module.exports = __webpack_public_path__ + "img/like.6a1e4271.png";